import moment from 'moment';

export const formatDate=(number)=>
{
     const newDate=moment(number).format('YYYY/MM/DD hh:mm A')
     return newDate;  
}

export const defaultSrc=()=>
{
     return require("../assets/icons/magiccall.png")
}
export const  random_bg_color=()=> {
     var x = Math.floor(Math.random() * 256);
     var y = Math.floor(Math.random() * 256);
     var z = Math.floor(Math.random() * 256);
     var bgColor = "rgb(" + x + "," + y + "," + z + ")";
   return bgColor;
}

const CAMPAIGN_KEY = "campaign";
const FACEBOOK_CAMPAIGN = "fb";

// Store the campaign from the entry url in sessionStorage so it survives in-app navigation.
// Any other campaign value, or landing on "/" without one, falls back to the normal flow.
export const syncCampaignFromUrl = () => {
     try {
          const campaign = new URLSearchParams(window.location.search).get(CAMPAIGN_KEY);
          if (campaign?.toLowerCase() === FACEBOOK_CAMPAIGN) {
               sessionStorage.setItem(CAMPAIGN_KEY, FACEBOOK_CAMPAIGN);
          } else if (campaign !== null || window.location.pathname === "/") {
               sessionStorage.removeItem(CAMPAIGN_KEY);
          }
     } catch (e) {
          console.log("Unable to access sessionStorage", e);
     }
}

// Facebook campaign users are always treated as active, without checkSub or HE.
export const isFacebookCampaign = () => {
     try {
          return sessionStorage.getItem(CAMPAIGN_KEY) === FACEBOOK_CAMPAIGN;
     } catch (e) {
          return false;
     }
}
